/* eslint-disable */
class MortgageUtils {
    /**
     * Проверяем примитив или объект на существование
     * @param {all} data - примитив или объект
     */
    isExist(data) {
        return (data !== null && !isNaN(+data) && data !== undefined);
    }

    /**
     * Работа с хранилищем данных, чтение и запись
     * @param {String} key - название ключа в хранилище
     * @param {Number} value - значение ключа в хранилище
     */
    accessStorage(key, value) {
        let storage = window.sessionStorage;
        return (this.isExist(value)) ?
            storage.setItem(key, value) :
            (parseInt(storage.getItem(key)) || storage.getItem(key));
    }

    removeStorage(key) {
        let storage = window.sessionStorage;
        storage.removeItem(key);
    }

    /**
     * Получаем из экземпляра слайдера его название и текущее положение ползунка
     * @param {Object} obj - экземпляр HTB для текущего инпута
     */
    getObjectData(obj) {
        return {
            key  : $(obj.$input).attr('name'),
            data : obj.from
        };
    }

    /**
     * Совершаем нужные вычисления для операндов
     * @param {String} action - флаг, определяющий, какое действие необходимо совершить над операндами
     * @param {Number} a - операнд
     * @param {Number} b - операнд
     */
    calc(action, a, b) {
        switch (action) {
            case 'creditAmount':
                return a - b;
            case 'creditAmountPretty':
                return (a - b).toLocaleString('ru-Ru') + ' руб.';
            case 'creditPercent':
                return parseInt(((b / a) * 100).toFixed());
            case 'creditPercentPretty':
                return (((b / a) * 100).toFixed()  + '%');
            case 'monthlyPaymentPretty':
                return parseInt(a.toFixed()).toLocaleString('ru-Ru') + ' руб./мес.';
        }
    }

    /**
     * Высчитываем сумму и процент кредита
     * Если процент больше 100, выделяем его красным, а сумму кредита не выводим
     */
    calcCredit() {
        let price    = this.accessStorage('price[min]', null);
        let firstPay = this.accessStorage('first-pay[min]', null);
        let percent  = this.calc('creditPercentPretty', price, firstPay);
        let amount   = this.calc('creditAmount', price, firstPay) >= 0 ?
            this.calc('creditAmountPretty', price, firstPay) :
            '—';
        this.accessStorage('creditAmount', this.calc('creditAmount', price, firstPay));
        this.accessStorage('creditPercent', this.calc('creditPercent', price, firstPay));
        return {
            amount : amount,
            percent: percent
        };
    }

    /**
     * Выбираем необходимое склонение постфикса
     * @param {Number} num - число, определяющее склонение
     */
    decodePostfix(num) {
        let postfixGod = [1, 21, 31];
        return (postfixGod.includes(num))  ? 'годa'  : 'лет';
    }

    /**
     * Проверка на наличие значений в инпуте
     * @param {Object} input - активный DOM элемент input
     * @param {String} value - значение inputa
     */
    use$Value(input, value) {
        return (value === undefined) ? $(input).val() : $(input).val(value);
    }

    /**
     * Проверка на наличие значений в инпуте
     * @param {Object} obj - экземпляр HTB для текущего ползунка
     * @param {Object} data - все значения слайдера
     * @param {String} regexp - регулярное выражение, исключающее всё, кроме цифр и точки
     */
    checkInputedData(obj, data, regexp) {
        let newDataFrom = +($(obj).val().replace(regexp, ''));
        data.from = (newDataFrom < data.min) ? data.min :
                    (newDataFrom > data.max) ? data.max : newDataFrom;
    }

    /**
     * Функция ограничения ввода символов с клавиатуры
     * @param {Object} e - событие
     */
    preventNaNSymbolsEnter(e) {
        let functionalKeys = [8, 9, 13, 17, 18, 35, 36, 37, 39, 46];
        if (!functionalKeys.includes(e.which) &&
            (e.which > 57 || e.which < 48) &&
            (e.which > 105 || e.which < 96) &&
            (e.which > 123 || e.which < 112)) {
            e.preventDefault();
        }
    }

    /**
     * Обработчик нажатий клавиш Tab, Enter, Escape
     * Tab, Enter проверяют корректность заполнения инпута, обновляют слайдеры и значения банков
     * @param {Object} e - событие
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего ползунка
     * @param {Object} input - активный DOM элемент input
     * @param {String} regexp - регулярное выражение, исключающее всё, кроме цифр и точки
     */
    onKeyDownEvent(e, data, obj, input, regexp) {
        switch (e.which) {
            case 13:
                this.checkInputedData(input, data, regexp);
                obj.updateSlidersValues(data, 'set');
                //obj.slider.update();
                obj.update();
                $(input).blur();
                break;
            case 27:
                $(input).blur();
                break;
        }
    }

    /**
     * Функция склонения слов
     */
    declOfNum(n, titles) {
        return titles[n % 10 === 1 &&
        n % 100 !== 11 ? 0 : n % 10 >= 2 &&
        n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ?
            1 : 2];
    }
}

export default MortgageUtils;

/* eslint-enable */
